import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: `${API_URL}api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ==================== CATÁLOGO ITEMS ====================
export const catalogoItemsAPI = {
  getAll: (activo = null) => {
    const params = activo !== null ? { activo } : {};
    return api.get('/catalogo-items', { params });
  },
  getById: (id) => api.get(`/catalogo-items/${id}`),
  create: (data) => api.post('/catalogo-items', data),
  update: (id, data) => api.put(`/catalogo-items/${id}`, data),
  delete: (id, force = false) => api.delete(`/catalogo-items/${id}`, { params: { force } }),
  getDesglose: (id, cantidad = 1.0) => api.get(`/catalogo-items/${id}/desglose`, { params: { cantidad } }),
};

// ==================== CATEGORÍAS ====================
export const categoriasAPI = {
  getAll: () => api.get('/categorias'),
  getActivas: () => api.get('/categorias/activas'),
  getById: (id) => api.get(`/categorias/${id}`),
  create: (data) => api.post('/categorias', data),
  update: (id, data) => api.put(`/categorias/${id}`, data),
  delete: (id) => api.delete(`/categorias/${id}`),
  inicializar: () => api.post('/categorias/inicializar'),
};

// ==================== RUBROS ====================
export const rubrosAPI = {
  getSugeridos: () => api.get('/rubros-sugeridos'),
  getAll: () => api.get('/rubros'),
  create: (data) => api.post('/rubros', data),
  delete: (id, force = false) => api.delete(`/rubros/${id}`, { params: { force } }),
};

// ==================== OBRAS ====================
export const obrasAPI = {
  getAll: () => api.get('/obras'),
  getById: (id) => api.get(`/obras/${id}`),
  create: (data, rubros_ids = []) => {
    return api.post('/obras', {
      ...data,
      rubros_ids: rubros_ids
    });
  },
  update: (id, data, rubros_ids = null) => {
    const payload = { ...data };
    if (rubros_ids !== null) {
      payload.rubros_ids = rubros_ids;
    }
    return api.put(`/obras/${id}`, payload);
  },
  delete: (id) => api.delete(`/obras/${id}`),
};

// ==================== PRESUPUESTOS ====================
export const presupuestosAPI = {
  getAll: (obra_id = null) => {
    const params = obra_id ? { obra_id } : {};
    return api.get('/presupuestos', { params });
  },
  getById: (id) => api.get(`/presupuestos/${id}`),
  getItems: (presupuestoId) => api.get(`/presupuesto-items/presupuesto/${presupuestoId}`),
  create: (data) => api.post('/presupuestos', data),
  update: (id, data) => api.put(`/presupuestos/${id}`, data),
  delete: (id) => api.delete(`/presupuestos/${id}`),
  crearNuevaVersion: (id) => api.post(`/presupuestos/${id}/nueva-version`),
  quitarReferencia: (id) => api.delete(`/presupuestos/${id}/quitar-referencia`),
  addItem: (presupuestoId, data) => api.post('/presupuesto-items', { presupuesto_id: presupuestoId, ...data }),
  updateItem: (itemId, data) => api.put(`/presupuesto-items/${itemId}`, data),
  deleteItem: (itemId) => api.delete(`/presupuesto-items/${itemId}`),
};

// ==================== PRESUPUESTO ITEMS ====================
export const presupuestoItemsAPI = {
  getByPresupuesto: (presupuesto_id) => api.get('/presupuesto-items', { params: { presupuesto_id } }),
  create: (data) => api.post('/presupuesto-items', data),
  update: (id, data) => api.put(`/presupuesto-items/${id}`, data),
  delete: (id) => api.delete(`/presupuesto-items/${id}`),
};

// ==================== COTIZACIONES ====================
export const cotizacionesAPI = {
  getAll: (obra_id) => {
    const params = obra_id ? { obra_id } : {};
    return api.get('/cotizaciones', { params });
  },
  getById: (id) => api.get(`/cotizaciones/${id}`),
  getByLinkPublico: (link_publico) => api.get(`/cotizaciones/publico/${link_publico}`),
  create: (data) => api.post('/cotizaciones', data),
  delete: (id) => api.delete(`/cotizaciones/${id}`),
  marcarRecibida: (link_publico, comentario) => 
    api.post(`/cotizaciones/publico/${link_publico}/recibir`, { comentario }),
};


// ==================== CRONOGRAMAS ====================
export const cronogramasAPI = {
  getAll: (obra_id) => {
    const params = obra_id ? { obra_id } : {};
    return api.get('/cronogramas', { params });
  },
  getById: (id) => api.get(`/cronogramas/${id}`),
  create: (data) => api.post('/cronogramas', data),
  update: (id, data) => api.put(`/cronogramas/${id}`, data),
  delete: (id) => api.delete(`/cronogramas/${id}`),
  recalcularFechas: (id, nueva_fecha_inicio) => 
    api.post(`/cronogramas/${id}/recalcular-fechas`, { nueva_fecha_inicio }),
};

// ==================== CRONOGRAMA TAREAS ====================
export const cronogramaTareasAPI = {
  getByCronograma: (cronograma_id) => api.get('/cronograma-tareas', { params: { cronograma_id } }),
  getById: (id) => api.get(`/cronograma-tareas/${id}`),
  create: (data) => api.post('/cronograma-tareas', data),
  update: (id, data) => api.put(`/cronograma-tareas/${id}`, data),
  updateEstado: (id, estado) => api.put(`/cronograma-tareas/${id}/estado`, null, { params: { estado } }),
  delete: (id) => api.delete(`/cronograma-tareas/${id}`),
};


// ==================== DASHBOARD ====================
export const dashboardAPI = {
  getStats: () => api.get('/dashboard'),
};

// ==================== GASTOS ====================
export const gastosAPI = {
  getAll: () => api.get('/gastos'),
  getByObra: (obra_id) => api.get(`/gastos/obra/${obra_id}`),
  create: (data) => api.post('/gastos', data),
  update: (id, data) => api.put(`/gastos/${id}`, data),
  delete: (id) => api.delete(`/gastos/${id}`),
  uploadComprobante: (gasto_id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/gastos/${gasto_id}/comprobantes`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getComprobante: (gasto_id, filename) => 
    `${API_URL}/api/gastos/${gasto_id}/comprobantes/${filename}`,
  deleteComprobante: (gasto_id, filename) => 
    api.delete(`/gastos/${gasto_id}/comprobantes/${filename}`),
};

// ==================== FINANZAS ====================
export const conceptosFinancierosAPI = {
  getAll: () => api.get('/conceptos-financieros'),
  getById: (id) => api.get(`/conceptos-financieros/${id}`),
  create: (data) => api.post('/conceptos-financieros', data),
  update: (id, data) => api.put(`/conceptos-financieros/${id}`, data),
  delete: (id) => api.delete(`/conceptos-financieros/${id}`),
  inicializar: () => api.post('/conceptos-financieros/inicializar'),
};

export const movimientosFinancierosAPI = {
  getAll: (filters = {}) => api.get('/movimientos-financieros', { params: filters }),
  getById: (id) => api.get(`/movimientos-financieros/${id}`),
  create: (data) => api.post('/movimientos-financieros', data),
  update: (id, data) => api.put(`/movimientos-financieros/${id}`, data),
  delete: (id) => api.delete(`/movimientos-financieros/${id}`),
  getDashboard: (obra_id = null) => {
    const params = obra_id ? { obra_id } : {};
    return api.get('/movimientos-financieros/dashboard/resumen', { params });
  },
};

export default api;
